import { FC, ReactElement, useMemo } from 'react';
import { Route } from 'react-router-dom';
import AboutScreen from '../AboutScreen/AboutScreen';
import ContactUsScreen from '../ContactUsScreen/ContactUsScreen';
import CookiesScreen from '../CookiesScreen/CookiesScreen';
import ManageFAQScreen from '../ManageFAQScreen/ManageFAQScreen';
import PrivacyPolicyScreen from '../PrivacyPolicyScreen/PrivacyPolicyScreen';
import TermsAndConditionsScreen from '../TermsAndConditionsScreen/TermsAndConditionsScreen';
import FranchiseScreen from '../FranchiseScreen/FranchiseScreen';
import ScreenTabsNavigation, { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from 'src/view/containers/Headers/Headers';
import { SCREENS } from 'src/constants/screens';

const WebsiteInfoScreen: FC = (): ReactElement => {
  const navigationOptions = useMemo((): IScreenTab[] => {
    return [
      { path: SCREENS.SETTINGS_WEBSITE_ABOUT(), title: 'about_tab' },
      { path: SCREENS.SETTINGS_WEBSITE_TERMS_CONDITIONS(), title: 'terms_&_conditions_tab' },
      { path: SCREENS.SETTINGS_WEBSITE_PRIVACY_POLICY(), title: 'privacy_policy_tab' },
      { path: SCREENS.SETTINGS_WEBSITE_CONTACT_US(), title: 'contact_us_tab' },
      { path: SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ(), title: 'manage_faq' },
      { path: SCREENS.SETTINGS_WEBSITE_COOKIES(), title: 'cookies_tab' },
      { path: SCREENS.SETTINGS_WEBSITE_FRANCHISE(), title: 'website_info_franchise_tab' },
    ];
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="website_info" path={SCREENS.SETTINGS()} />
      </Headers>

      <div className="d-flex flex-column flex-grow-1 pt-6">
        <ScreenTabsNavigation options={navigationOptions} className="mb-4" />

        <Route path={SCREENS.SETTINGS_WEBSITE_ABOUT()} component={AboutScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_TERMS_CONDITIONS()} component={TermsAndConditionsScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_PRIVACY_POLICY()} component={PrivacyPolicyScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_CONTACT_US()} component={ContactUsScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ()} component={ManageFAQScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_COOKIES()} component={CookiesScreen} />
        <Route path={SCREENS.SETTINGS_WEBSITE_FRANCHISE()} component={FranchiseScreen} />
      </div>
    </div>
  );
};

export default WebsiteInfoScreen;
